import { z } from 'zod'
import { BaseFilter } from './base'

export type SelectFilterValue = string

export class SelectFilter extends BaseFilter<SelectFilterValue> {
  static readonly schema = z.string()

  parse(urlValue: string): SelectFilterValue | null {
    if (!urlValue) {return null}
    return this.safeParse(urlValue)
  }

  serialize(value: SelectFilterValue): string {
    return value
  }

  getSchema() {
    return SelectFilter.schema
  }
}
